import Cookies from 'universal-cookie';
import * as uuidv1 from 'uuid';

export const getVisitorToken = () => {
  const tokenName = '_utk';
  const cookies = new Cookies();
  let token = cookies.get(tokenName);
  if (!token) {
    token = uuidv1();
    const t = new Date();
    cookies.set(tokenName, token, {
      path: '/',
      expires: new Date(t.getFullYear() + 1, t.getMonth(), t.getDay()),
    });
  }
  return token;
};



// WEBPACK FOOTER //
// ./src/helpers/cookies/getVisitorToken.ts